import React from "react";
import { Link } from "react-router-dom";

const DeliveryOne = () => {
  const deliveryInfo = {
    title: "Fast & Reliable Delivery",
    subtitle:
      "Estimated delivery times vary by seller, product availability, and location.",
    buttonText: "Shop Now",
    buttonLink: "/shop",
    note: "Shipping options and delivery estimates are shown at checkout.",
  };

  return (
    <>
      <style>{`
        .delivery-section {
          padding: 20px 0;
        }

        .delivery-card {
          background: linear-gradient(120deg, #e8f9e9 0%, #f3faf2 40%, #bbd4f8 100%);
          border-radius: 20px;
          border: 1.5px solid #299e60;
          display: flex;
          align-items: flex-end;
          min-height: 200px;
          overflow: visible;
          position: relative;
        }

        .delivery-img-left {
          flex: 0 0 260px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: -1px;
        }

        .delivery-img-left img {
          width: 270px;
          height: 290px;
          object-fit: contain;
          object-position: bottom;
          display: block;
        }

        .delivery-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 36px 16px;
        }

        .delivery-content h4 {
          font-size: 22px;
          font-weight: 700;
          color: #0f5c32;
          margin: 0 0 8px 0;
          line-height: 1.25;
        }

        .delivery-content p {
          font-size: 13px;
          color: #2d7a50;
          line-height: 1.6;
          margin: 0 0 20px 0;
          max-width: 320px;
        }

        .delivery-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #299e60;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          padding: 10px 28px;
          border-radius: 999px;
          text-decoration: none;
          transition: background 0.2s;
        }

        .delivery-btn:hover {
          background: #1e7a47;
          color: #fff;
        }

        .delivery-img-right {
          flex: 0 0 190px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: -1px;
        }

        .delivery-img-right img {
          width: 190px;
          height: 190px;
          object-fit: contain;
          object-position: bottom;
          display: block;
          margin-top: -20px;
        }

        /* Tablet */
        @media (max-width: 768px) {
          .delivery-card {
            min-height: unset;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
          }

          .delivery-img-left {
            flex: 0 0 auto;
            margin-bottom: 0;
            order: 2;
          }

          .delivery-img-left img {
            width: 160px;
            height: 175px;
          }

          .delivery-content {
            order: 1;
            padding: 28px 20px 12px;
          }

          .delivery-content h4 {
            font-size: 19px;
          }

          .delivery-img-right {
            display: none;
          }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .delivery-card {
            border-radius: 14px;
          }

          .delivery-content {
            padding: 24px 16px 8px;
          }

          .delivery-content h4 {
            font-size: 17px;
          }

          .delivery-content p {
            font-size: 12px;
          }

          .delivery-btn {
            font-size: 13px;
            padding: 9px 22px;
          }

          .delivery-img-left img {
            width: 130px;
            height: 145px;
          }
        }
      `}</style>

      <div className="delivery-section">
        <div className="container container-lg">
          <div className="delivery-card">

            {/* LEFT — Delivery Man */}
            <div className="delivery-img-left">
              <img
                src="assets/images/thumbs/Delivery/delivery-man.png"
                alt="Delivery Man"
              />
            </div>

            {/* CENTER — Content */}
            <div className="delivery-content">
              <h4>{deliveryInfo.title}</h4>
              <p>{deliveryInfo.subtitle}</p>
              <Link to={deliveryInfo.buttonLink} className="delivery-btn">
                {deliveryInfo.buttonText}
                <i className="ph ph-arrow-right" style={{ fontSize: "16px" }} />
              </Link>
            </div>

            {/* RIGHT — Product image */}
            <div className="delivery-img-right">
              <img
                src="assets/images/thumbs/Delivery/special-items.png"
                alt="Special Snacks"
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryOne;